import React from 'react';
import {
  ChatIcon,
  CodeIcon,
  CurrencyDollarIcon,
  DatabaseIcon,
  UserGroupIcon,
  PuzzleIcon,
  PresentationChartBarIcon,
} from '@heroicons/react/outline';

import {cx} from '../util';

const TYPE_ICONS = {
  PM: UserGroupIcon,
  Behavioral: ChatIcon,
  'Behavioral-IB': ChatIcon,
  Algorithms: CodeIcon,
  'System-Design': PuzzleIcon,
  SQL: DatabaseIcon,
  'Data-Science-ML': PresentationChartBarIcon,
  Frontend: CodeIcon,
  'Investment-Banking': CurrencyDollarIcon,

  // Pramp interview types
  product_case_study: UserGroupIcon,
  behavioral: ChatIcon,
  algorithms: CodeIcon,
  system_design: PuzzleIcon,
  applied_data_science: PresentationChartBarIcon,
  frontend: CodeIcon,
};

const InterviewTypeTheme = {
  PM: {accent: '#7C3AED', soft: '#F5F3FF'},
  Algorithms: {accent: '#2563EB', soft: '#EFF6FF'},
  'System-Design': {accent: '#0D9488', soft: '#F0FDFA'},
  Behavioral: {accent: '#DB2777', soft: '#FDF2F8'},
  'Behavioral-IB': {accent: '#DB2777', soft: '#FDF2F8'},
  SQL: {accent: '#DC2626', soft: '#FEF2F2'},
  'Data-Science-ML': {accent: '#16A34A', soft: '#F0FDF4'},
  Frontend: {accent: '#EA580C', soft: '#FFF7ED'},
  'Investment-Banking': {accent: '#D97706', soft: '#FFFBEB'},

  // Pramp interview types
  product_case_study: {accent: '#7C3AED', soft: '#F5F3FF'},
  algorithms: {accent: '#2563EB', soft: '#EFF6FF'},
  system_design: {accent: '#0D9488', soft: '#F0FDFA'},
  behavioral: {accent: '#DB2777', soft: '#FDF2F8'},
  applied_data_science: {accent: '#16A34A', soft: '#F0FDF4'},
  frontend: {accent: '#EA580C', soft: '#FFF7ED'},
};

export const getTypeTheme = (typeKey) => InterviewTypeTheme[typeKey]
  || {accent: '#5524E0', soft: '#F5F3FF'};

export const InterviewTypeIcon = ({typeKey, className, size = 'lg'}) => {
  const Icon = TYPE_ICONS[typeKey];
  const theme = getTypeTheme(typeKey);
  const chipSize = size === 'sm' ? 'h-8 w-8' : 'h-10 w-10';
  const iconSize = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';

  return (
    <div
      className={cx(chipSize, 'rounded-lg flex items-center justify-center shrink-0', className)}
      style={{background: theme.soft}}
    >
      {Icon && <Icon className={iconSize} style={{color: theme.accent}} />}
    </div>
  );
};
